module.exports = __webpack_public_path__ + "static/two_explain.59546106.png";